import { RouteComponentProps } from 'react-router-dom';
import isArray from 'lodash/isArray';
import qs from 'query-string';
import { AppDispatch } from 'src/store';
import { IQueryParams } from 'src/types';
import { removeEmpty } from 'src/utils/removeEmpty';
import { createAction } from '@reduxjs/toolkit';

import { IMerchant } from '../../merchants/types';

import {
  createMerchantRequest,
  deleteProviderImageRequest,
  fetchCredentialsRequest,
  fetchIntegrationRequest,
  fetchMerchantsRequest,
  fetchProvidersMerchantsRequest,
  fetchProvidersRequest,
  updateProviderImageRequest,
} from './requestHandlers';
import { ICredential, IIntegration, IProviderListData, IUpdateProviderLogo } from './types';

const defaultParams = {
  page: '0',
  size: '10',
};

export const loadProvidersStart = createAction('providers_payment/load/start');
export const loadProvidersSuccess = createAction<IProviderListData>('providers_payment/load/success');
export const loadProvidersMerchantsSuccess = createAction<IProviderListData>('providers_payment/merchants/load/success');

export const loadProvidersRequest = (history: RouteComponentProps['history'], params: IQueryParams = {}, search: string) => {
  return async (dispatch: AppDispatch): Promise<boolean> => {
    dispatch(loadProvidersStart());

    const initialParams = qs.parse(history.location.search);
    const mergedParams = { ...defaultParams, ...initialParams, ...removeEmpty(params) };
    const searchRequest = search.length ? { providerName: search } : {};
    const data = await fetchProvidersRequest(mergedParams, searchRequest);
    if (data) {
      dispatch(loadProvidersSuccess(data));
    }
    history.replace({
      search: qs.stringify(mergedParams, { skipNull: true }),
    });
    return true;
  };
};

export const loadProvidersMerchantsRequest = (
  history: RouteComponentProps['history'],
  params: IQueryParams = {},
  isInitialLoading?: boolean,
  type?: string,
) => {
  return async (dispatch: AppDispatch): Promise<boolean> => {
    if (isInitialLoading) {
      dispatch(loadProvidersStart());
    }

    const initialParams = qs.parse(history.location.search);
    const mergedParams = type === 'reset' ? defaultParams : removeEmpty({ ...defaultParams, ...initialParams, ...params });
    if (mergedParams?.providerNameSelect) {
      mergedParams.providerNameSelect = isArray(mergedParams.providerNameSelect)
        ? mergedParams.providerNameSelect
        : [mergedParams.providerNameSelect];
    }

    if (mergedParams?.integrationMerchantAccountGroupIds) {
      mergedParams.integrationMerchantAccountGroupIds = isArray(mergedParams.integrationMerchantAccountGroupIds)
        ? mergedParams.integrationMerchantAccountGroupIds
        : [mergedParams.integrationMerchantAccountGroupIds];
    }

    const data = await fetchProvidersMerchantsRequest(mergedParams);
    if (data) {
      dispatch(loadProvidersMerchantsSuccess(data));
    }
    history.replace({
      search: qs.stringify(mergedParams, { skipNull: true }),
    });
    return true;
  };
};
export const fetchMerchants = async (): Promise<IMerchant[]> => fetchMerchantsRequest();
export const fetchIntegration = async (type: string, providerIds: number[]): Promise<IIntegration[]> =>
  fetchIntegrationRequest(type, providerIds);
export const createMerchant = async (type: string, data: Partial<IMerchant>): Promise<Partial<IMerchant>> =>
  createMerchantRequest(type, data);
export const updateProviderImage = (data: IUpdateProviderLogo): Promise<void> => updateProviderImageRequest(data);
export const deleteProviderImage = (id: string): Promise<void> => deleteProviderImageRequest(id);
export const fetchCredentials = async (type: string, name: string): Promise<ICredential[]> => fetchCredentialsRequest(type, name);
